import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { useState } from 'react';

import Button from 'components/field/Button';
import TextEditor from 'components/field/TextEditor';
import Alert from 'components/global/Alert';
import Modal from 'components/global/Modal';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

const CustomEmailModal = NiceModal.create(({ value, setValue, initProps }) => {
	const [localValue, setLocalValue] = useState(value);
	const modal = useModal();

	const handleCloseModal = async () => {
		modal.remove();
	};

	const handleSave = async () => {
		setValue(localValue);
		handleCloseModal();
	};

	return (
		<Modal fullwidth maxWidth="xx-large" closeButton={false}>
			<ModalTitle>
				<Alert content="customEmailModalDescription" showIcon />
			</ModalTitle>
			<ModalContent>
				<TextEditor value={localValue} setValue={setLocalValue} initProps={initProps} />
			</ModalContent>

			<ModalActions>
				<Button label="cancel" onClick={handleCloseModal} />
				<Button
					label="save"
					onClick={handleSave}
					disabled={JSON.stringify(value) === JSON.stringify(localValue)}
				/>
			</ModalActions>
		</Modal>
	);
});

export default CustomEmailModal;
